module.exports = __webpack_public_path__ + "img/FRACTURADO.png";